// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"DragAndDrop_dropzone__1_4Qk","chip":"DragAndDrop_chip__R4vRO"};